<div class="container-fuild h-100 p-3 prevent-select">
  <div class="row mt-3 main-content tablet-screen-responsive mx-auto">
    <div class="col-12 text-center align-self-center">
      <div class="my-4"
        ><h4>{{ 'delete_account_warning' | translate }}</h4></div
      >
      <div class="my-4 prevent-select">{{ 'delete_account_message' | translate }}</div>

      <button
        class="btn btn-secondary wkt-button-secondary-color-white wkt-button border-left-radius border-right-radius btn-lg w-100 mt-4 mb-3"
        (click)="confirmRemove()"
        type="button"
        >{{ 'delete_account_validate' | translate }}</button
      >

      <button
        class="btn btn-outline-secondary wkt-button border-left-radius border-right-radius btn-lg w-100 my-3"
        (click)="notRemove()"
        type="button"
        >{{ 'delete_account_cancel' | translate }}</button
      >
    </div>
  </div>
</div>
